import React, { useState, useEffect } from 'react';
import loadRazorpay from '../context/loadRazorpay';
import { styled } from '@mui/material/styles';
import {
  Box,
  Stack,
  Typography,
  Button,
  Switch,
  FormControlLabel,
  Card,
  CardContent,
  Chip,
  Paper,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Constellation1 from '../assets/images/consti_1.svg';
import Constellation2 from '../assets/images/consti_2.svg';
import Constellation3 from '../assets/images/consti_3.svg';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { BackgroundDiv } from '../components/StyledComponents';
import BreadcrumbNavbar from '../components/BreadcrumbNavbar';
import { useNavigate } from 'react-router-dom';
import { PricingContainer } from '../components/PricingContainer';

const TokenPack = () => {
  return (
    <BackgroundDiv saturn={true}>
      <BreadcrumbNavbar />
      <PricingContainer />
    </BackgroundDiv>
  );
};

export default TokenPack;
